import autocomplete from 'autocompleter';

const apiKey = '67f48dee973e38fa8a4c6ce377256e99';
const inputCity = document.getElementById("order-city");
const inputWarehouse = document.getElementById("order-warehouse");
let cityItems = [];
let warehouseItems = [];

if(inputCity !== null) {
    cityAutocomplete();
    warehouseAutocomplete();    
}

async function loadApi(data)
{
    let response = await fetch('https://api.novaposhta.ua/v2.0/json/', {
        method: 'POST',
        body: JSON.stringify(data),
    });

    let result = await response.json();

    return await result.data;
}

function cityAutocomplete() 
{
    loadApi({
        apiKey: apiKey,
        modelName: "Address",
        calledMethod: "getCities",
        methodProperties: {
            Limit: 10000000,
        },
    }).then(response => {
        cityItems = response;
    });

    autocomplete({
        input: inputCity,
        preventSubmit: true,
        showOnFocus: true,
        
        fetch: function(text, update) {
            text = text.toLowerCase();
            let suggestions = cityItems.filter(n => n.Description.toLowerCase().startsWith(text))      
            update(suggestions);
        },
    
        render: function(item, currentValue) {
            var div = document.createElement("div");
            div.textContent = item.Description;
            return div;
        },
    
        onSelect: function(item) {
            inputCity.value = item.Description;
            inputWarehouse.disabled = false;
            inputCity.dataset.ref = item.Ref;

            loadApi({
                apiKey: apiKey,
                modelName: "Address",
                calledMethod: "getWarehouses",
                methodProperties: {
                    CityRef: item.Ref,
                    Limit: 10000000,
                }
            }).then(response => {
                warehouseItems = response;
                inputWarehouse.focus();
            });
        },
    });        
}

function warehouseAutocomplete() 
{
    autocomplete({
        input: inputWarehouse,
        preventSubmit: true,
        showOnFocus: true,

        fetch: function(text, update) {
            text = text.toLowerCase();
            let suggestions = warehouseItems.filter(
                n => n.Description.toLowerCase().includes(text)
            );
            update(suggestions);
        },
    
        render: function(item, currentValue) {
            var div = document.createElement("div");
            div.textContent = item.Description;
            return div;
        },
    
        onSelect: function(item) {
            inputWarehouse.value = item.Description;
        },
    });        
}
